import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { updateOrganizer, getOrganizerById } from "api/company.api";
import OrganizerForm from "components/company/OrganizerForm";
import { organizerRoute } from "../../../utils/permissionRoute";
import Toast from "components/Toast";
export default function EditOrganizer() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState("");
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });

  useEffect(() => {
    fetchOrganizer();
  }, []);

  const fetchOrganizer = async () => {
    try {
      const res = await getOrganizerById(id);
      const data = res.data;

      const existingStaff = Array.isArray(data.staffDetails)
        ? data.staffDetails
        : [];

      const createDefaultStaff = () => ({
        email: "",
        password: "",
        permissions: organizerRoute,
      });

      const normalizeStaffItem = (staffItem) => {
        if (!staffItem) return createDefaultStaff();

        return {
          ...staffItem,
          // Use existing permissions if present and non-empty; otherwise default to organizerRoute
          permissions:
            staffItem.customPermissions &&
            staffItem.customPermissions.length > 0
              ? staffItem.customPermissions
              : organizerRoute,
        };
      };

      // Normalize array and ensure at least 2 staff slots are always populated
      const normalizedStaff = [
        normalizeStaffItem(existingStaff[0]),
        normalizeStaffItem(existingStaff[1]),
        ...existingStaff.slice(2).map(normalizeStaffItem), // Normalize any extra staff beyond index 1
      ];

      setInitialData({
        ...data,
        projectModules: Array.isArray(data.projectModules)
          ? data.projectModules
          : typeof data.projectModules === "string"
          ? data.projectModules.split(",")
          : [],
        staffDetails: normalizedStaff,
      });
    } catch (err) {
      console.error("Fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (data) => {
    try {
      const formData = new FormData();
      const existingSponsorUrls = [];
      const featuresPayload = (data.eventFeatures || []).map((feat) => ({
        title: feat.title,
        description: feat.description,
        existingLogo: typeof feat.logo === "string" ? feat.logo : "",
        hasNewLogo: feat.logo instanceof File,
      }));

      Object.entries(data).forEach(([key, value]) => {
        // 1. JSON Array / Object Fields
        if (
          [
            "staffDetails",
            "communicationEmails",
            "ticketDiscounts",
            "ticketPriceTiers",
            "projectModules",
            "eventTimings",
            "eventHighlights",
            "whyParticipate",
            "hospitalitySection",
          ].includes(key)
        ) {
          formData.append(key, JSON.stringify(value || []));
        } else if (key === "eventFeatures") {
          formData.append("eventFeatures", JSON.stringify(featuresPayload));
        }
        // 2. Single File Uploads
        else if (
          (key === "companyLogo" ||
            key === "companyLogoBlack" ||
            key === "eventBanner") &&
          value instanceof File
        ) {
          formData.append(key, value);
        }
        // 3. Sponsor Images Array Handling
        else if (key === "sponsorImages" && Array.isArray(value)) {
          value.forEach((item) => {
            if (item instanceof File) {
              formData.append("sponsorImages", item); // New binary files
            } else if (typeof item === "string") {
              existingSponsorUrls.push(item); // Preserved existing URLs
            }
          });
        }
        // 4. Primitive Values
        else if (
          value !== null &&
          value !== "" &&
          value !== undefined &&
          typeof value !== "object"
        ) {
          formData.append(key, value);
        }
      });

      // Send preserved existing image URLs under the key expected by the backend
      formData.append(
        "existingSponsorImages",
        JSON.stringify(existingSponsorUrls)
      );
      (data.eventFeatures || []).forEach((feat) => {
        if (feat.logo instanceof File) {
          formData.append("featureLogos", feat.logo);
        }
      });
      if (data.hospitalitySection?.image instanceof File) {
        formData.append("hospitalityImage", data.hospitalitySection.image);
      } else if (typeof data.hospitalitySection?.image === "string") {
        formData.append(
          "existingHospitalityImage",
          data.hospitalitySection.image
        );
      }
      await updateOrganizer(id, formData);
      setToast({
        open: true,
        title: "Success",
        message: "Event updated successfully",
        type: "success",
      });
      // navigate("/admin/companies");
    } catch (err) {
      console.error("UPDATE ERROR:", err.response?.data || err.message);
      setAlert(err.response?.data?.message || "Failed to update company");
    }
  };

  if (loading) return <p className="p-6">Loading...</p>;

  return (
    <>
      <Toast
        open={toast.open}
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={1500}
        onClose={() => {
          setToast((prev) => ({ ...prev, open: false }));
          navigate("/admin/companies");
        }}
      />
      <OrganizerForm
        initialData={initialData}
        onSubmit={handleSubmit}
        submitLabel="Update Organizer"
        alert={alert}
        setAlert={setAlert}
        onBack={() => navigate(-1)}
        organizerRoute={organizerRoute}
      />
    </>
  );
}
